export {
  initEventTracker,
  disposeEventTracker,
  logEvent,
  flushEvents,
  setUserContext,
  setProjectContext,
  getDiagnostics,
} from './tracker';

export { parseEventName } from './eventName';
export { trackOperation } from './trackOperation';

export type {
  TelemetryConfig,
  LoggedEvent,
  EventType,
  UserContext,
  ProjectContext,
  AuthProvider,
  AwsCredentials,
  TelemetryDiagnostics,
} from './types';

export { SCHEMA_VERSION } from './types';

// __testSink and _resetForTests are deliberately NOT re-exported from the public
// surface. They are accessible via `import ... from '@entourage-yearbooks/ecs-telemetry-module/dist/tracker'`
// for the module's own tests, but consumers should never see them in autocomplete.
